const ro = {
    'The file size is bigger than 5MB!': 'Dimensiunea fișierului este mai mare de 5MB!',
    'Something went wrong! Please try uploading the file again!':
        'Ceva nu a mers bine! Vă rugăm să încărcați fișierul din nou!',
    'Wrong file type! Only JPEG, PNG formats are supported!':
        'Tipul fișierului este greșit! Doar fișiere de tip JPEG și PNG sunt suportate!',
    'Wrong file type! Only PDF format is supported!':
        'Tipul fișierului este greșit! Doar fișiere de tip PDF sunt suportate!',
    'Wrong file type! Only JPEG, PNG and PDF formats are supported!':
        'Tipul fișierului este greșit! Doar fișiere de tip JPEG, PNG, PDF sunt suportate!',
};

export default { ro };
